import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SubjectTest} from '../models/subject-test';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubjectTestService {

  constructor(private http: HttpClient) { }

  getSubjectTests(): Promise<SubjectTest[]> {
    return this.http.get<SubjectTest[]>(`${environment.apiEndpoint}api/v1/subject-test`).toPromise();
  }

  getSubjectTestById(subjectTestId: string): Promise<any> {
    return this.http.get<SubjectTest>(`${environment.apiEndpoint}api/v1/subject-test/${subjectTestId}`).toPromise();
  }

  getSubjectTestByLesson(subjectTestLesson: string): Promise<any> {
    return this.http.get<SubjectTest>(`${environment.apiEndpoint}api/v1/subject-test/by-lesson/${subjectTestLesson}`).toPromise();
  }

  submitSubjectTest(studentId: string, subjectTestId: string, markedOptions: any): Promise<any> {
    const data = {studentId, subjectTestId, markedOptions};
    return this.http.post<SubjectTest>(
      `${environment.apiEndpoint}api/v1/subject-test/submit/${subjectTestId}`,
      data,
      {responseType: 'json', observe: 'body'}
    ).toPromise();
  }
}
